import {useCommerceAPI} from '../commerce-api/contexts'
import {usePageProductsCache} from '../hoc/with-page-products-cache'

/**
 * Hook to get function to obtain products from api.shopperProducts.getProducts that caches the results in memory.
 *
 * @returns {function({parameters: {ids: string}}): Promise<{data: Array}>}
 */
const useCachedProducts = () => {
    const api = useCommerceAPI()
    const productsCache = usePageProductsCache()

    return productsCache?.getProducts || api.shopperProducts.getProducts
}

export default useCachedProducts
